import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MoneyModule } from '@x/common/money';
import { ShippingCostCalculation } from '@x/ecommerce/shop-client';

@Component({
  selector: 'x-order-item-delivery-note',
  templateUrl: './order-item-delivery-note.component.html',
  styleUrls: ['./order-item-delivery-note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: { class: 'x-order-item-delivery-note' },
  imports: [MoneyModule, NgIf],
})
export class OrderItemDeliveryNoteComponent {
  @Input() calculation: ShippingCostCalculation;
}
